import { render } from "./Language.vue?vue&type=template&id=14370dfa&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=14370dfa&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14370dfa"]])

export default __exports__